
import { Box, Button, Typography } from '@mui/material';

export default function EmptyState({ icon, title, description, actionLabel, onAction, sx }) {
  return (
    <Box
      sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', textAlign: 'center', gap: 1, py: 5, px: 2,
        color: 'text.secondary', ...sx,
      }}
    >
      {icon && <Box sx={{ color: 'text.disabled', display: 'flex' }}>{icon}</Box>}
      <Typography variant="body2" fontWeight={600} color="text.primary">{title}</Typography>
      {description && <Typography variant="caption">{description}</Typography>}
      {actionLabel && onAction && (
        <Button size="small" variant="outlined" onClick={onAction} sx={{ mt: 1 }}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}